import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import uniqid from 'uniqid';
import Swal from 'sweetalert2';
import { Container, Grid, TextField } from '@mui/material';
import { getCollectionsComplete, updateData, getDate } from '../../assets/js/functions';
import logo from '../../assets/images/header/Logo.svg';
import puntero from '../../assets/images/inicio/puntero.png';
import diploma from '../../assets/images/aprobo/Certificado.png';
import creaDiplomaPDF from '../../assets/js/diploma';
import './styles.scss';

export default function Reprobo() {
  const navigate = useNavigate();
  const [intento, setIntento] = useState(0);
  const userID = sessionStorage.getItem('mx');
  const usuario = sessionStorage.getItem('mx');
  const [user, setUser] = useState({});

  useEffect(() => {
    getIntento();
  }, []);

  const getIntento = async () => {
    console.log('%c getIntento()', 'color: #00ff22');
    let usuarioMX = sessionStorage.getItem('mx');
    const data = await getCollectionsComplete('usuarios/' + usuarioMX);
    const dataIntento = await getCollectionsComplete(`preguntas/${userID}`);
    if (dataIntento && typeof dataIntento.intento !== 'undefined') {
      setIntento(dataIntento.intento);
      console.log('%c dataIntento' + dataIntento.intento, 'color: #ff7e29');
    } else {
      setIntento(0);
      console.log('%c Intento' + dataIntento, 'color: #ff7e29');
    }
    setUser(data);
    guardarIntentoEnBD();
  };

  const guardarIntentoEnBD = async () => {
    const dataFormat = parseInt(intento || 0);
    updateData('preguntas', usuario, { intento: dataFormat + 1 })
      .catch((e) => {
        console.log('Error: ' + e);
      })
      .then(() => {
        console.log('%c Intento' + intento, 'color: #ff7e29');
      });
  };

  const empezarDeNuevo = async (e) => {
    console.log('%c empezarDeNuevo' + intento, 'color:rgb(255, 255, 56)');
    if (intento == undefined || intento == null || intento == '' || intento == NaN) {
      window.location.replace('/preguntas');
    } else {
      if (intento < 2) {
        window.location.replace('/preguntas');
      } else {
        navigate('/limite-intentos');
      }
    }
  };

  const mensajeDeError = () => {
    Swal.fire({
      title: '¡Alto!',
      text: 'El plazo para realizar este ejercicio ha concluido.',
      icon: 'warning',
      confirmButtonText: 'Cerrar',
      confirmButtonColor: '#0033a0',
    });
  };

  const crearDiploma = async () => {
    console.log('%c ssss', 'color: #ff7e29');
    console.log(userID);
    console.log(usuario);
    console.log(user);

    creaDiplomaPDF(user.nombre, diploma);
  };

  return (
    <>
      <div id='reprobo'>
        <div className='header'>
          <img src={logo} alt='logo' />
        </div>
        <Container maxWidth='md'>
          <Grid container justifyContent='center' alignItems='center' spacing={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div className='container'>
                <h1>¡ES NECESARIO REFORZAR ALGUNOS ELEMENTOS!</h1>
                <p>
                  Pero no te desanimes, sabemos que estás en el
                  <br /> camino para desarrollar las habilidades
                  <br /> necesarias para liderar de manera efectiva
                  <br /> desde una gestión remota. Te invitamos a reforzar
                  <br /> conocimientos en los temas clave del programa,
                  <br /> recuerda que cada paso cuenta para convertirte
                  <br /> en el líder que tu equipo necesita.
                  <br /> Estamos aquí para apoyarte en este proceso.
                </p>
                <h2>
                  ¡Estamos seguros de que <br />
                  marcarás la diferencia!
                </h2>
                <h2>Respuestas {localStorage.getItem('puntos') || 0} / 15</h2>
                <div className='iniciar'>
                  <img src={puntero} alt='img' className='puntero' />
                  <div className='btn-iniciar' onClick={() => mensajeDeError()}>
                    Repetir evaluacion
                  </div>
                  <div className='btn-iniciar' onClick={() => crearDiploma()}>
                    Descargar Certificado
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
}
